import PropTypes from "prop-types";
import React from "react";
import styles from "./ReportHeader.module.css";
import Print from "./Print.svg";
import More from "./More.svg"

export const ReportHeader = ({ header, reportType }) => {
  return (
    <div className={styles.header}>
      {header}
      {reportType == "major" ? (
        <img src={More} alt="Ellipses" />
      ) : reportType == "membership" ? (
        <img src={Print} alt="Print Icon" />
      ) : ""}
    </div>
  );
};

ReportHeader.propTypes = {
  header: PropTypes.string.isRequired,
};
